module.exports = __webpack_public_path__ + "img/wow.5bc2a5cd.svg";